import { loadWebConfigurations } from '@newStore/documentApi/documentApiState';
import { selectTitleWithDescriptionNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { getAllOfResource } from '@newStore/externalData/externalDataState';
import { pathMap } from '@newStore/externalData/externalDataTypes';
import { referenceFrames } from '@newStore/referenceFrames/referenceFrames';
import { loadReferenceFrame } from '@newStore/referenceFrames/referenceFramesState';
import { referencedInProHomeCannotUnpublish } from '@newStore/validation/validationRules/referencedInProHomeCannotUnpublish';
import { NodeType, type RootNodeConfig } from '@nodeTypeConfig/configTypes';
import { authorsComponent } from '@nodeTypeConfig/helpers/editComponents/authorsComponent';
import { curriculumSelectorComponent } from '@nodeTypeConfig/helpers/editComponents/curriculumSelector';
import { introDescriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import { menuItemReference } from '@nodeTypeConfig/helpers/editComponents/menuItemReference';
import { proContactsComponent } from '@nodeTypeConfig/helpers/editComponents/proContactsComponent';
import { proThemesComponent } from '@nodeTypeConfig/helpers/editComponents/proDocumentStandardComponents';
import { proLinks } from '@nodeTypeConfig/helpers/editComponents/proLinksAndMenuReferences';
import { proThemeAudienceTab } from '@nodeTypeConfig/helpers/editComponents/proThemeAudienceTab';
import { proThumbnailComponent } from '@nodeTypeConfig/helpers/editComponents/proThumbnailComponent';
import { publishComponent } from '@nodeTypeConfig/helpers/editComponents/publishComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import { asideWebType } from '@nodeTypeConfig/helpers/editComponents/webConfigComponents';
import { webSitesProHref } from '@store/api/apiRoutes';
import { accessRights } from '../../../reduxLoop/helpers/accessRights';
import { settings } from '../../settings';
import { proDefaultBuildingBlocks } from '../helpers/buildingBlocks/proDefaultBuildingBlocks';
// Generic Pro Theme in the list screen or onLoading before it has the full document context and becomes something more specific
// Also WEBPAGE2 with invalid WebConfig will not match a specific Pro Theme and will be a WEBPAGE2
export const WEBPAGE2: RootNodeConfig = {
  nodeSelector: selectTitleWithDescriptionNode,
  validationRules: [],
  information: {
    definiteArticle: true,
    single: 'PRO.-thema',
    plural: "PRO.-thema's",
    icon: require('../../../../img/icons/webpage.svg'),
    category: 'PRO',
  },
  onLoadActions: [
    loadWebConfigurations(),
    loadReferenceFrame({ referenceFrame: referenceFrames.pro }),
    getAllOfResource({ resource: pathMap.namedSets, refresh: false }),
  ],
  createDefaults: {
    accessRights: accessRights.publiek.namedsets,
    descendantsAccessRights: accessRights.publiek.namedsets,
  },
  websiteHref: webSitesProHref,
  buildingBlocks: proDefaultBuildingBlocks,
  tocTypes: [NodeType.PRO_THEME_SECTION, NodeType.FAQ_GROUP],
  edit: [
    titleComponent,
    introDescriptionComponent,
    { ...proThumbnailComponent, width: 6, label: 'Tegelfoto' },
    {
      ...authorsComponent,
      label: 'Themaverantwoordelijke',
    },
    {
      ...publishComponent,
      validations: [...(publishComponent.validations || []), referencedInProHomeCannotUnpublish],
    },
    proThemesComponent,
    curriculumSelectorComponent,
    proContactsComponent,
    menuItemReference,
    proLinks,
  ],
  audienceTab: proThemeAudienceTab,
  webTab: [asideWebType],
  addAccessRightsToAudienceTab: true,
  isCreatable: true,
  isSearchable: true,
  isImportable: true,
  isCloneable: true,
  websiteEdition: [
    {
      domain: settings.domains.pro,
    },
  ],
  allowSuggestions: true,
  globalAttachmentsGroupContainer: true,
};
